import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../service/authentication.service";
import { AlertService } from "../service/alert.service";
import { SpinnerService } from "../service/spinner.service";
import { finalize } from "rxjs/operators";
import { CustomErrorStateMatcher } from "../helpers/customerrorstate";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { SignInService } from "../service/signin.service";
import { UserLogged } from "../dto/user/userLogged";
import jwtDecode from 'jwt-decode';
import { Role } from "../enum/role";
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit, OnDestroy {
  public loginForm: FormGroup;
  public login: string;
  public password: string;
  public submitted = false;
  esMatcher = new CustomErrorStateMatcher();
  private unsubscribe: Subscription[] = [];
  constructor(private router: Router, private authenticationService: AuthenticationService, private signInService: SignInService, private translateService: TranslateService,
    private formBuilder: FormBuilder, private alertService: AlertService, private spinnerService: SpinnerService) {
  }

  ngOnInit() {
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/home']);
    }
    this.translateService.use(this.translateService.currentLang);
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required]
    });
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  async onSubmit() {
    if (this.loginForm.invalid || this.submitted) {
      return;
    }
    this.submitted = true;
    this.spinnerService.show();
    this.unsubscribe.push(this.signInService.PasswordSignIn(this.f.username.value, this.f.password.value).pipe(finalize(() => {
      this.spinnerService.hide();
      this.submitted = false;
    }))
      .subscribe(
        data => {
          try {
            this.authenticationService.login(data['token']);
            // this.authenticationService.inactivity();
            this.router.navigate(['/home']);
          } catch (ex) {
            Sentry.captureException(ex);
          }
        }));
  }
}

